import { FC } from 'react';
import { StyledCurrentLocation } from './currentLocation.styles';
import { SyntheticEvent } from 'react';

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    google: any;
  }
}

export interface CurrentLocationViewProps {
  currentLocationLabel: string;
  clickHandler: (e: SyntheticEvent) => void;
}

const CurrentLocationView: FC<CurrentLocationViewProps> = ({ currentLocationLabel, clickHandler }) => {
  return (
    <StyledCurrentLocation>
      <a
        href="#"
        onTouchStart={(event: SyntheticEvent): void => clickHandler(event)}
        onClick={(event: SyntheticEvent): void => clickHandler(event)}
        className="t-subtitle-m"
      >
        <span className="icon-nearby">{currentLocationLabel}</span>
      </a>
    </StyledCurrentLocation>
  );
};

export default CurrentLocationView;
